import { SignInButton, useClerk } from "@clerk/clerk-react";
import React, { useState } from "react";
import Spinner from "../../../components/atoms/Spinner";
import useRememberedUser from "../hooks/useRememberedUser";

/**
 * EnhancedSignIn - Sign in component with remembered user functionality
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Button content
 */
function EnhancedSignIn({ children }) {
  const { signIn } = useClerk();
  const { rememberedUser } = useRememberedUser();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  // Quick login function that uses remembered user data
  const handleQuickLogin = async () => {
    if (!rememberedUser || !rememberedUser.email) return;

    try {
      setIsLoggingIn(true);
      console.log("Attempting quick sign in for:", rememberedUser.email);

      // Redirect to Clerk sign-in with email prefilled
      await signIn.create({
        identifier: rememberedUser.email,
        redirectUrl: window.location.href,
      });

      // Allow UI to show loading state briefly for feedback
      setTimeout(() => {
        setIsLoggingIn(false);
      }, 2000);
    } catch (error) {
      console.error("Quick login failed:", error);
      setIsLoggingIn(false);
    }
  };

  return (
    <div className="flex flex-col space-y-4">
      {rememberedUser && (
        <button
          onClick={handleQuickLogin}
          disabled={isLoggingIn}
          className="flex items-center justify-center space-x-2 px-4 py-2 bg-[--elita-secondary] text-[--elita-primary] border border-[--elita-primary] rounded-md hover:bg-[--elita-secondary-hover] hover:text-[#5dc9fc] hover:border-[#5dc9fc] transform hover:scale-[1.02] transition-all duration-200"
        >
          {isLoggingIn ? (
            <span className="flex items-center">
              <Spinner size="sm" className="mr-2" />
              Signing in...
            </span>
          ) : (
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
              <span>Quick Sign In as {rememberedUser.email.split("@")[0]}</span>
            </>
          )}
        </button>
      )}
      <SignInButton mode="modal">{children}</SignInButton>
    </div>
  );
}

export default EnhancedSignIn;
